<template>
  <div class="bg-white rounded-[8px] p-4 border border-gray-100">
    <div class="h-8 flex flex-row items-center justify-between gap-3">
      <span class="text-base leading-6 font-semibold text-gray-800 truncate">
        {{ webhook.name || webhook.url }}
      </span>
      <span class="flex flex-row gap-[5px]">
        <button-v2
          v-if="hasEditPermission('Webhooks')"
          variant="ghost"
          size="sm"
          icon="edit"
          :aria-label="$t('INTEGRATION_SETTINGS.WEBHOOK.EDIT.BUTTON_TEXT')"
          @click="$emit('edit', webhook)"
        />
        <button-v2
          v-if="hasDeletePermission('Webhooks')"
          variant="ghost"
          color="danger"
          size="sm"
          icon="delete"
          :aria-label="$t('INTEGRATION_SETTINGS.WEBHOOK.DELETE.BUTTON_TEXT')"
          @click="$emit('delete', webhook)"
        />
      </span>
    </div>

    <copy-field-v2 class="mt-5" compact :value="webhook.url" />

    <div v-if="visibleEvents.length" class="mt-4 flex flex-row flex-wrap gap-2">
      <tag-v2
        v-for="event in visibleEvents"
        :key="event"
        color="primary-03"
        size="md"
      >
        {{ getEventLabel(event) }}
      </tag-v2>
      <tag-v2 v-if="hiddenEventsCount" color="primary-03" size="md">
        {{
          $t('INTEGRATION_SETTINGS.WEBHOOK.CARD.MORE', {
            count: hiddenEventsCount,
          })
        }}
      </tag-v2>
    </div>

    <div
      v-if="webhook.updated_at"
      class="mt-4 flex flex-row items-center gap-2 text-sm leading-5"
    >
      <span class="text-gray-600">
        {{ $t('INTEGRATION_SETTINGS.WEBHOOK.CARD.LAST_UPDATED') }}
      </span>
      <span class="text-gray-600">{{ lastUpdatedAt }}</span>
    </div>
  </div>
</template>

<script>
import { isSameYear, fromUnixTime } from 'date-fns';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';
import timeMixin from 'dashboard/mixins/time';
import webhookMixin from './webhookMixin';

const MAX_VISIBLE_EVENTS = 4;

export default {
  name: 'WebhookCard',
  mixins: [hasPermissionMixin, timeMixin, webhookMixin],
  props: {
    webhook: {
      type: Object,
      required: true,
    },
  },
  computed: {
    subscriptions() {
      return this.webhook.subscriptions || [];
    },
    visibleEvents() {
      return this.subscriptions.slice(0, MAX_VISIBLE_EVENTS);
    },
    hiddenEventsCount() {
      return Math.max(this.subscriptions.length - MAX_VISIBLE_EVENTS, 0);
    },
    lastUpdatedAt() {
      const { updated_at: updatedAt } = this.webhook;
      const [dayMonth, withYear] =
        this.$root.$i18n.locale === 'he'
          ? ["d 'ב'MMM", "d 'ב'MMM yyyy"]
          : ['MMM d', 'MMM d, yyyy'];
      const dateFormat = isSameYear(fromUnixTime(updatedAt), new Date())
        ? dayMonth
        : withYear;
      return this.plainTimestamp(updatedAt, dateFormat);
    },
  },
};
</script>
